var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-collapse",
    {
      staticClass: "p-4 border bg-light container-fluid",
      model: {
        value: _vm.showContestInfo,
        callback: function($$v) {
          _vm.showContestInfo = $$v
        },
        expression: "showContestInfo"
      }
    },
    [
      _c("div", { staticClass: "justify-content-end" }, [
        _c(
          "button",
          {
            staticClass: "close",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                _vm.showContestInfo = false
              }
            }
          },
          [_vm._v(" × ")]
        )
      ]),
      _c(
        "b-container",
        [
          _c(
            "b-row",
            { staticClass: "p-1" },
            [
              _c("b-col", { staticClass: "col-12 p-1 text-center" }, [
                _c("h3", { staticClass: "mb-3 display-4" }, [
                  _vm._v(
                    " " + _vm._s(_vm.T.userNextRegisteredContestTitle) + " "
                  )
                ])
              ])
            ],
            1
          ),
          _c(
            "b-row",
            {
              staticClass: "p-1 flex-column flex-sm-row",
              attrs: { "align-v": "center" }
            },
            [
              _c(
                "b-col",
                { staticClass: "col-md-4 col-sm-12 p-1 text-center" },
                [
                  _c(
                    "h5",
                    { staticClass: "m-0" },
                    [
                      _c("a", [
                        _vm._v(_vm._s(_vm.nextRegisteredContest.title))
                      ]),
                      _vm.nextRegisteredContest.recommended
                        ? _c("font-awesome-icon", {
                            ref: "contestIconRecommended",
                            staticClass: "ml-1",
                            attrs: { icon: "award" }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              ),
              _c(
                "b-col",
                { staticClass: "col-md-4 col-sm-12 p-1 text-center" },
                [
                  _c("font-awesome-icon", {
                    staticClass: "mr-1",
                    attrs: { icon: "clipboard-list" }
                  }),
                  _vm._v(
                    " " + _vm._s(_vm.nextRegisteredContest.organizer) + " "
                  )
                ],
                1
              ),
              _c(
                "b-col",
                { staticClass: "col-md-4 col-sm-12 p-1 text-center" },
                [
                  _c("font-awesome-icon", {
                    staticClass: "mr-1",
                    attrs: { icon: "users" }
                  }),
                  _vm._v(
                    " " + _vm._s(_vm.nextRegisteredContest.contestants) + " "
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-row",
            {
              staticClass: "p-1 flex-column flex-sm-row",
              attrs: { "align-v": "center" }
            },
            [
              _c(
                "b-col",
                { staticClass: "col-md-4 col-sm-12 p-1 text-center" },
                [
                  _c("font-awesome-icon", { attrs: { icon: "calendar-alt" } }),
                  _vm.isContestStarted
                    ? _c("a", { attrs: { href: _vm.startTimeLink } }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.ui.formatString(_vm.T.contestStartedTime, {
                                startedDate: _vm.startContestDate
                              })
                            ) +
                            " "
                        )
                      ])
                    : _c("a", { attrs: { href: _vm.startTimeLink } }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.ui.formatString(_vm.T.contestStartTime, {
                                startDate: _vm.startContestDate
                              })
                            ) +
                            " "
                        )
                      ])
                ],
                1
              ),
              _c(
                "b-col",
                { staticClass: "col-md-4 col-sm-12 p-1 text-center" },
                [
                  _c("font-awesome-icon", {
                    staticClass: "mr-1",
                    attrs: { icon: "stopwatch" }
                  }),
                  _vm._v(" " + _vm._s(_vm.T.wordsDuration) + ": "),
                  _vm.isContestStarted
                    ? _c("omegaup-countdown", {
                        staticClass: "clock",
                        attrs: {
                          "target-time": _vm.nextRegisteredContest.finish_time
                        },
                        on: {
                          finish: function($event) {
                            _vm.now = new Date()
                          }
                        }
                      })
                    : _c("p", { staticClass: "d-inline" }, [
                        _vm._v(" " + _vm._s(_vm.contestDuration) + " ")
                      ])
                ],
                1
              ),
              _c(
                "b-col",
                { staticClass: "col-md-4 col-sm-12 p-1 text-center" },
                [
                  _vm.isContestStarted
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-primary w-75",
                          attrs: { type: "button" },
                          on: { click: _vm.onClick }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.T.userNextRegisteredContestButtonEnter
                              ) +
                              " "
                          )
                        ]
                      )
                    : _c(
                        "button",
                        {
                          staticClass: "btn btn-primary w-75",
                          attrs: { type: "button" },
                          on: { click: _vm.onClick }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.T.userNextRegisteredContestButtonSeeDetails
                              ) +
                              " "
                          )
                        ]
                      )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }